import * as Sentry from '@sentry/remix';
import { useEffect } from 'react';
import { useLocation, useMatches } from '@remix-run/react';

const sentryInit = () => {
  Sentry.init({
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,

    integrations: [
      Sentry.browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      Sentry.replayIntegration(),
    ],
  });
};

export default sentryInit;
